<div class="employee-deetail-dialog" mat-dialog-content>
  <!-- LOADER -->
  <span class="view-container" *ngIf="doc">
    <mat-toolbar class="view-toolbar">
      <mat-toolbar-row>
        <!-- document-selected-header-info -->
        <div class="view-description">
          <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-file">
          </mat-icon>
          <div class="view-description-text" fxLayout="column" fxLayoutAlign="center start">
            <h3 matLine [title]="doc.documentationTypeName"> {{ doc.documentationTypeName}}</h3>
            <h5 matLine> Id: {{doc.id}} - {{'common.documentDateLbl' | transloco}}: {{ doc.documentDate | date :'dd/MM/yyyy' }}</h5>
          </div>
        </div>
        <div class="view-actions">
          <div fxLayout="row" fxLayoutAlign="end center">
            <app-file-document-state [item]="doc" [showSmallChips]="false" *ngIf="data.showDocumentState">
            </app-file-document-state>
            <div class="divider-vert"></div>
            <!-- PDF-controls -->
            <app-pdf-wrapper-controls [pdfWrapper]="pdfWrapper" [showPrint]="true" [showSave]="true"
              [disabled]="workInProgress || disableButtons" [showZoomIn]="filePdf" [showZoomOut]="filePdf" [(showRemove)]="showRemove"
              (OnRemoveFile)="removeFile()">
            </app-pdf-wrapper-controls>
            <!--cancel-document -->
            <button mat-icon-button *ngIf="canCancel && !isCanceled()" (click)="cancelFileDocument()"
              title="{{'common.rejectDocumentBtn' | transloco}}" [disabled]="workInProgress || disableButtons">
              <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-file-times"></mat-icon>
            </button>
            <!-- delete-document -->
            <button *ngIf="canDelete" mat-icon-button (click)="deleteFileDocument()" title="{{'common.deleteDocumentBtn' | transloco}}"
              [disabled]="workInProgress || disableButtons">
              <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-trash"></mat-icon>
            </button>
            <!-- metadata-view -->
            <button mat-icon-button *ngIf="showData"  (click)="this.showMetadatos()" title="{{'common.seeMoreDataBtn' | transloco}}" [disabled]="workInProgress || disableButtons">
              <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-file-alt"></mat-icon>
            </button>
            <!-- view rejected motive -->
            <button id="btnViewMotie" mat-icon-button (click)="canceledChapa = true" title="{{'common.seeRejectionReasonLbl' | transloco}}"
              *ngIf="isCanceled() && !canceledChapa">
              <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-eye"></mat-icon>
            </button>
            <div class="divider-vert"></div>
            <!-- close-modal-only -->
            <button mat-icon-button (click)="dialogClose()" title="{{'common.closeBtn' | transloco}}" [disabled]="workInProgress">
              <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-times"></mat-icon>
            </button>
          </div>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
    <span class="view-content">
      <mat-progress-bar mode="indeterminate" [style.display]="(workInProgress) ? 'block' : 'none'">
      </mat-progress-bar>
      <!-- employee-pending-upload -->
      <app-chapa [className]="'upload-bk'" [text]="'common.documentPendingUpload' | transloco"
        *ngIf="doc && doc.isUploadPending()">
      </app-chapa>
      <!-- PDF-viewer -->
      <app-pdf-wrapper [showControls]="false" #pdfWrapper [doc]="doc" [file]="filePdf" [fileName]="fileName"
        [hidden]="canceledChapa" [autoView]="false">
      </app-pdf-wrapper>
      <app-chapa [className]="'info-empty'" [icon]="'fa-file-times'" [text]="'common.documentRejectedLbl' | transloco"
        [subText]="doc.rejectedMotive ? ('common.reason' | transloco) : ''" [infoExtra]="doc.rejectedMotive" [actionIcon]="'fa-eye'"
        [actionText]="'common.seeDocumentLbl' | transloco" (actionClick)="canceledChapa = false;" *ngIf="canceledChapa"></app-chapa>
    </span>
  </span>
</div>
